import { render } from "./UserPerformanceMeter.vue?vue&type=template&id=1243a193&scoped=true"
import script from "./UserPerformanceMeter.vue?vue&type=script&lang=js"
export * from "./UserPerformanceMeter.vue?vue&type=script&lang=js"

import "./UserPerformanceMeter.vue?vue&type=style&index=0&id=1243a193&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1243a193"]])

export default __exports__